// app/javascript/controllers/logbook_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["bookTypeSelect", "componentSelect", "photoOnlyToggle", "detailSections", "engineTachContainer"]
    static values = { photoMode: Boolean }

    connect() {
        if (this.photoModeValue && this.hasDetailSectionsTarget) {
            this.detailSectionsTarget.style.display = 'none'
        }
        // Render engine tach inputs for already-selected book types on page load (edit form)
        if (this.hasBookTypeSelectTarget) {
            this.#renderEngineTachInputs(this.#selectedBookTypeIds())
        }
    }

    handleSubmit() {
        const btn = document.querySelector('[form="' + this.element.id + '"]')
        if (!btn) return
        btn.disabled = true
        btn.innerHTML = '<i class="fas fa-spinner fa-spin me-1"></i> Saving...'
    }

    togglePhotoMode() {
        const isPhotoOnly = this.photoOnlyToggleTarget.checked

        if (this.hasDetailSectionsTarget) {
            this.detailSectionsTarget.style.display = isPhotoOnly ? 'none' : ''
        }
    }

    handleBookTypeChange(event) {
        const selectedIds = this.#selectedBookTypeIds()
        this.#renderEngineTachInputs(selectedIds)
    }

    handleComponentChange(event) {
        const selectedOptions = Array.from(event.target.selectedOptions)
        const selectedIds = selectedOptions.map(option => option.value)
        console.log("Selected components:", selectedIds)
    }

    // --- private helpers ---

    #selectedBookTypeIds() {
        if (!this.hasBookTypeSelectTarget) return []
        return Array.from(this.bookTypeSelectTarget.selectedOptions).map(o => parseInt(o.value))
    }

    #engineBookTypes() {
        const aircraftDiv = document.getElementById('aircraftDiv')
        if (!aircraftDiv) return []
        try {
            return JSON.parse(aircraftDiv.dataset.engineBookTypes || '[]')
        } catch { return [] }
    }

    #existingTachValues() {
        if (!this.hasEngineTachContainerTarget) return {}
        try {
            return JSON.parse(this.engineTachContainerTarget.dataset.existingEngineTachs || '{}')
        } catch { return {} }
    }

    #renderEngineTachInputs(selectedIds) {
        if (!this.hasEngineTachContainerTarget) return

        const engineBookTypes = this.#engineBookTypes()
        // Only show tach inputs for engine book_types that are currently selected
        const selectedEngines = engineBookTypes.filter(bt => selectedIds.includes(bt.id))

        if (selectedEngines.length === 0) {
            this.engineTachContainerTarget.innerHTML = ''
            return
        }

        const existingTachs = this.#existingTachValues()

        const html = selectedEngines.map(bt => {
            const inputId = `engine_tach_${bt.id}`
            const existingValue = existingTachs[bt.id] != null ? existingTachs[bt.id] : ''
            return `
              <div class="mb-3">
                <label for="${inputId}" class="form-label">${bt.name} Tach</label>
                <input type="number"
                       id="${inputId}"
                       name="logbook[engine_tach_values][${bt.id}]"
                       value="${existingValue}"
                       step="any"
                       class="form-control"
                       placeholder="Tach hours for ${bt.name}">
              </div>`
        }).join('')

        this.engineTachContainerTarget.innerHTML = html
    }
}
